/**
 * 将同一视觉行内的 .multicolumn-card__info_title 对齐为该行最高标题高度（替代固定 min-height）。
 * 与 section-multicolumn.css 中 750px 断点一致；窄屏不设置内联高度。
 *
 * 注意：不要对 ul.multicolumn-list 使用 ResizeObserver —— 子标题 min-height 会改变列表高度，
 * 会形成“改高度 → 触发观察 → 再改”的循环，拖曳缩放窗口时会闪动。
 */
(function () {
  const MQ = window.matchMedia('(min-width: 750px)');
  const imagesWithLoadHook = new WeakSet();
  let resizeTimer;
  let otherTimer;

  function groupByRow(elements, tolerance) {
    const rows = [];
    elements.forEach(function (el) {
      const top = el.getBoundingClientRect().top;
      let bucket = null;
      for (let i = 0; i < rows.length; i++) {
        if (Math.abs(rows[i].top - top) <= tolerance) {
          bucket = rows[i];
          break;
        }
      }
      if (!bucket) {
        bucket = { top: top, els: [] };
        rows.push(bucket);
      }
      bucket.els.push(el);
    });
    return rows.map(function (r) {
      return r.els;
    });
  }

  /** 延迟加载图片加载完成后再对齐一次（不监听列表尺寸，避免与 min-height 互相触发） */
  function bindImageLoads(list) {
    list.querySelectorAll('img').forEach(function (img) {
      if (imagesWithLoadHook.has(img)) return;
      imagesWithLoadHook.add(img);
      if (img.complete) return;
      img.addEventListener('load', scheduleFromOther, { once: true });
      img.addEventListener('error', scheduleFromOther, { once: true });
    });
  }

  function equalizeList(list) {
    var titles = [].slice.call(list.querySelectorAll('li .multicolumn-card__info_title'));

    if (!MQ.matches || titles.length === 0) {
      titles.forEach(function (t) {
        t.style.minHeight = '';
      });
      return;
    }

    titles.forEach(function (t) {
      t.style.minHeight = '';
    });
    void list.offsetHeight;

    var rowGroups = groupByRow(titles, 5);
    rowGroups.forEach(function (group) {
      if (group.length <= 1) return;

      var maxH = 0;
      group.forEach(function (el) {
        var h = el.getBoundingClientRect().height;
        if (h > maxH) maxH = h;
      });
      var next = Math.ceil(maxH) + 'px';
      group.forEach(function (el) {
        if (el.style.minHeight !== next) {
          el.style.minHeight = next;
        }
      });
    });
  }

  function runAll() {
    document.querySelectorAll('ul.multicolumn-list').forEach(function (list) {
      bindImageLoads(list);
      equalizeList(list);
    });
  }

  /** 窗口缩放：只在停顿后跑一次，避免拖曳时反复清空/设置 min-height 造成闪动 */
  function scheduleFromResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(runAll, 280);
  }

  function scheduleFromOther() {
    clearTimeout(otherTimer);
    otherTimer = setTimeout(runAll, 50);
  }

  function boot() {
    window.addEventListener('resize', scheduleFromResize);
    window.addEventListener('orientationchange', scheduleFromResize);
    document.addEventListener('shopify:section:load', scheduleFromOther);
    MQ.addEventListener('change', scheduleFromOther);

    var afterReady = runAll;
    if (document.fonts && typeof document.fonts.ready !== 'undefined' && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(afterReady).catch(afterReady);
    } else {
      afterReady();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
